module.exports = __webpack_public_path__ + "img/44.db4ebae9.png";